// React Imports
import { ReactElement, useEffect } from "react";
import { useDispatch } from "react-redux";

// Component Imports
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";

// Style Imports
import "./online-trading-access.scss";
import { CREATE_BREADCRUMB } from "../../store/actions";
import OnlineTradingTable from "./components/online-trading-table/online-trading-table";

const OnlineTradingAccess: React.FC = (): ReactElement => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: CREATE_BREADCRUMB,
      payload: {
        breadcrumb: [
          {
            text: "Online trade access",
            type: "link",
            link: "/customers/online-trade-access",
          },
        ],
      },
    });
  }, []);


  return (
    <div className="waiting-approvals-container flex flex-col">
      <div className="flex items-center justify-between flex-wrap">
        <BreadcrumbComponent />
      </div>
      <OnlineTradingTable />
    </div>
  );
};

export default OnlineTradingAccess;
